<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head back="Convention.Volunteers.Roles.Edit" :backParams="$route.meta.backParams" title="Slots" subtitle="Manage the scheduled slots for a volunteer role." :readonly="$authorised('con/volunteers/access', 'read')">

		<app-content-head-actions-item text="Create" icon="create" v-on:click="onCreateClick" tooltip="Create single slot" />

		<app-content-head-actions-item text="Wizard" icon="wizard" v-on:click="onWizardClick" tooltip="Create multiple slots at once" />

		<app-content-head-actions-panel text="Export" icon="export" component="manager/common/panel/Export" :data="importexportData" :disabled="!collection.length" />

		<app-content-head-actions-item text="Delete" icon="delete" :danger="true" :disabled="!selected.length" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

		<app-content-filters-select v-model="filter.status" :allow-deselect="true" tooltip="Filter status" text="Status" :options="$util.options($constants.volunteers.slot.statusName)" />

		<app-content-filters-select v-model="filter.day" :allow-deselect="true" tooltip="Filter day" text="Day" :options="$util.options(references.days)" />


	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no slots found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />

				<app-table-column text="Name" />

				<app-table-column text="Day" />

				<app-table-column text="Starts" />

				<app-table-column text="Ends" />

				<app-table-column align="center" text="Volunteers" />

				<app-table-column align="center" text="Capacity" />

				<app-table-column />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">
				
					<app-table-cell-label :text="$constants.volunteers.slot.statusName[item.status]" :type="$constants.volunteers.slot.statusTheme[item.status]" :subtext="item.reference" />
					
					<app-table-cell-text :text="item.name" />
					
					<app-table-cell-text :text="references.days[item.day]" />
					
					<app-table-cell-text :text="item.date.start | formatDate('h:mma')" />
					
					<app-table-cell-text :text="item.date.end | formatDate('h:mma')" />
					
					<app-table-cell-text align="center" :text="item.count.filled" />
					
					<app-table-cell-text align="center" :text="item.capacity" />
					
					<app-table-cell-select :active="isSelected(item.id)" v-on:click="onSelectToggle(item.id)" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			references: {
				days: {}
			},
			filter: {
				status: 0,
				day: 0
			},
			layout: '120px 1fr 240px 100px 100px 100px 100px 40px',
			endpoint: 'convention/volunteers/roles/:role/slots',
			live: 'convention/volunteers/roles/:role/slots'
		}

	},

	created: function() {
	
		if (this.$route.query.day) {
		
			this.filter.day = this.$route.query.day

			this.$router.replace({
				query: null
			})

		}

	},

	computed: {
	
		importexportData: function() {

			return {
				columns: {
					'reference': 'Reference',
					'status': 'Status',
					'name': 'Name',
					'day': 'Day',
					'starts': 'Starts',
					'ends': 'Ends',
					'volunteers': 'Volunteers',
					'capacity': 'Capacity'
				},
				requiredColumns: [],
				valueMapping: {},
				params: this.getParams(),
				index: this.selectedIndex,
				endpoint: this.$endpoint(this.endpoint)
			}

		}
	
	},

	methods: {
	
		onWizardClick: function() {
		
			this.$router.push({
				name: 'Convention.Volunteers.Slots.Wizard'
			})
		
		}
	
	}

}

</script>

<style scoped>

</style>